import { Link } from "@tanstack/react-router";
import { Package } from "@/components/icons";
import type { OrderItemDTO } from "@/modules/orders/domain/types";
import { formatLak } from "@/shared/lib/currency";

type OrderItemCogsBreakdownProps = {
  item: OrderItemDTO;
  /** ซ่อนหัวข้อเมื่ออยู่ใน accordion แล้ว */
  hideTitle?: boolean;
};

export function OrderItemCogsBreakdown({
  item,
  hideTitle = false,
}: OrderItemCogsBreakdownProps) {
  const allocations = item.cogsAllocations ?? [];
  if (allocations.length === 0 && !item.missingLotQuantity) {
    return null;
  }

  return (
    <div className="mt-1.5 rounded-lg border border-border/60 bg-muted/20 px-3 py-2 text-xs">
      {!hideTitle ? (
        <p className="mb-1.5 font-medium text-muted-foreground">
          FIFO / COGS
          {item.lineCogsTotal ? (
            <span className="ml-2 text-foreground tabular-nums">
              ລວມ {formatLak(item.lineCogsTotal)}
            </span>
          ) : null}
        </p>
      ) : null}
      {allocations.length > 0 ? (
        <ul className="flex flex-col gap-1">
          {allocations.map((row) => (
            <li
              key={`${row.stockLotId}-${row.quantity}`}
              className="flex flex-wrap items-center justify-between gap-2"
            >
              <span className="flex min-w-0 items-center gap-1.5">
                <Package className="size-3 shrink-0 text-muted-foreground" />
                <Link
                  to="/app/inventory/receive/$id"
                  params={{ id: row.receiptId }}
                  className="truncate text-secondary underline-offset-2 hover:underline"
                >
                  {row.receiptNumber}
                </Link>
                <span className="text-muted-foreground">× {row.quantity}</span>
              </span>
              <span className="tabular-nums">
                {formatLak(row.lineCogs)}
                <span className="text-muted-foreground">
                  {" "}
                  @ {formatLak(row.unitLandedCost)}
                </span>
              </span>
            </li>
          ))}
        </ul>
      ) : null}
      {item.missingLotQuantity && item.missingLotQuantity > 0 ? (
        <p className={allocations.length > 0 ? "mt-1.5 text-destructive" : "text-destructive"}>
          {item.missingLotQuantity} ຊິ້ນ ບໍ່ມີ lot — COGS = 0
        </p>
      ) : null}
    </div>
  );
}
